import { memo } from "react"

const IconCloseSmall = () => {
  return (
    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.07593 0.734375H8.07593C9.1805 0.734375 10.0759 1.62981 10.0759 2.73438V8.73438C10.0759 9.83894 9.1805 10.7344 8.07593 10.7344H2.07593C0.971358 10.7344 0.0759277 9.83894 0.0759277 8.73438V2.73438C0.0759277 1.62981 0.971358 0.734375 2.07593 0.734375ZM6.81593 7.47437C6.96215 7.32797 6.96215 7.09078 6.81593 6.94438L5.60593 5.73438L6.81593 4.52437C6.95361 4.37662 6.94954 4.14637 6.80674 4.00356C6.66393 3.86076 6.43368 3.8567 6.28593 3.99437L5.07593 5.20437L3.86593 3.99437C3.71817 3.8567 3.48792 3.86076 3.34512 4.00356C3.20231 4.14637 3.19825 4.37662 3.33593 4.52437L4.54593 5.73438L3.33593 6.94438C3.1897 7.09078 3.1897 7.32797 3.33593 7.47437C3.40735 7.54296 3.50193 7.58222 3.60093 7.58437C3.70013 7.58322 3.79507 7.54382 3.86593 7.47437L5.07593 6.26437L6.28593 7.47437C6.35679 7.54382 6.45172 7.58322 6.55093 7.58437C6.64993 7.58222 6.74451 7.54296 6.81593 7.47437Z"
        fill="#ED4040"
      />
    </svg>
  )
}

export default memo(IconCloseSmall)
